export default {
  appStore: {
    apple: 'https://itunes.apple.com/app/id1448606032',
    google: 'market://details?id=com.myworkapp',
  },
};
